import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import AddressSelectField from './AddressSelectField';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2.5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: 8,
    },
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.colors?.lightBlue || '#5B65DC'}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
  sectionContent: {
    marginTop: theme.spacing(2),
    maxWidth: 1000,
    width: '100%',
  },
}));

const DeliveryInfoSection = ({ addresses, isEditable }) => {
  const classes = useStyles();
  const { en: { forms } } = useSelector((state) => state.i18n);

  return (
    <div className={classes.section}>
      <Typography className={classes.sectionTitle}>
        {forms.deliveryInformation || 'Delivery Information'}
      </Typography>
      <div className={classes.sectionContent}>
        <AddressSelectField
          name='address'
          type='text'
          required
          addresses={addresses}
          disabled={!isEditable}
        />
      </div>
    </div>
  );
};

DeliveryInfoSection.propTypes = {
  addresses: PropTypes.array.isRequired,
  isEditable: PropTypes.bool,
};

DeliveryInfoSection.defaultProps = {
  isEditable: true,
};

export default DeliveryInfoSection;
